import { FC, HTMLAttributes } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as CrossIcon } from "../../images/CrossIcon.svg";
import styles from "./ModalWindow.module.sass";
import cn from "classnames";

interface ModalWindowProps extends HTMLAttributes<HTMLDivElement> {
	close: () => void;
	transparent?: boolean;
	width?: string;
	scroll?: boolean;
	padding?: boolean;
}

export const ModalWindow: FC<ModalWindowProps> = ({
	close,
	transparent = true,
	width,
	children,
	scroll = true,
	padding = true,
}) => {
	// const overlayClickHandler = () => {
	// 	if (transparent) close();
	// };

	return createPortal(
		<div className={cn(styles.overlay, !transparent && styles.opaque)}>
			<div
				className={cn(
					styles["window-wrp"],
					styles[`${width}`],
					!scroll && styles.noScroll,
					styles[`window-wrp-padding-${padding}`],
				)}>
				<div className={cn(styles.window, !scroll && styles.noScroll, styles[`window-padding-${padding}`])}>
					<button onClick={close} className={styles.cross}>
						<CrossIcon />
					</button>
					{children}
				</div>
			</div>
		</div>,
		document.body,
	);
};
